import {handleAfterClick as oldHandleAfterClick, pushMessage, getRobotReplay} from '@/znzs/src/utils/chat';
import {beforeSend} from '@/znzs/new_src/utils/index';
import store from '@/znzs/new_src/vuex/index';
import {DIALOG_TYPE, DISPLAY_TYPE} from '@/znzs/new_src/constant/index.js';

/**
 * 直接调用旧版的发送消息接口
 * 添加流式聊天功能后，需要判断当前是否正在流失当中
 * @param  {...any} args
 */
export function handleAfterClick(...args) {
    // eslint-disable-next-line no-console
    console.log('调旧版发送消息');
    oldHandleAfterClick(...args);
}

/**
 * 机器人提问方法
 * 提供与旧版相同的功能，不同的函数签名
 */
export function sendQuestion({content, trigger, productId, shown = true}) {
    if (beforeSend(store)) {
        return;
    }
    if (shown) {
        pushMessage(DIALOG_TYPE.USER_QUESTION, DISPLAY_TYPE.TEXT, content);
    }
    if (!store.state.chat.socket) {
        // 获取机器人回复
        getRobotReplay(content, trigger, productId);
    }
    else {
        // 发送IM消息
        store.dispatch('chat/send', {content});
    }
}
